import { useState } from "react";
import { toast } from "sonner";
import { Phone, Pencil, Check, MessageCircle, Send, FileText } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export function QuickPhone({ booking, templates = [] }) {
  const [phone, setPhone] = useState(booking.phone || "");
  const [value, setValue] = useState(booking.phone || "");
  const [edit, setEdit] = useState(!booking.phone);
  const [saving, setSaving] = useState(false);
  const tid = (s) => `quick-phone-${s}-${booking.id}`;
  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.patch(`/bookings/${booking.id}/contact`, { phone: value });
      setPhone(data.phone);
      setValue(data.phone);
      setEdit(!data.phone);
      toast.success(data.phone ? "Telefono salvato" : "Telefono rimosso");
    } catch (e) {
      toast.error(errMsg(e));
    }
    setSaving(false);
  };
  const sendLink = (path = `/bookings/${booking.id}/link`) => async () => {
    const w = window.open("", "_blank");
    try {
      const { data } = await api.get(path);
      const url = `https://wa.me/${phone.replace(/^\+/, "")}?text=${encodeURIComponent(data.text)}`;
      if (w) w.location.href = url;
      else window.location.href = url;
    } catch (e) {
      if (w) w.close();
      toast.error(errMsg(e));
    }
  };
  const canSend = !["confermato", "cancellata"].includes(booking.status);
  if (!edit) {
    return (
      <div className="flex flex-wrap items-center gap-3 text-sm" data-testid={tid("view")}>
        <a href={`tel:${phone}`} className="flex items-center gap-1 font-medium text-stone-700 hover:text-primary" data-testid={tid("call")}><Phone className="h-4 w-4" />{phone}</a>
        <a href={`https://wa.me/${phone.replace(/^\+/, "")}`} target="_blank" rel="noreferrer" className="flex items-center gap-1 text-emerald-700 hover:underline" data-testid={tid("whatsapp")}><MessageCircle className="h-4 w-4" />WhatsApp</a>
        {canSend && <button type="button" onClick={sendLink()} className="flex items-center gap-1 rounded-full bg-emerald-600 px-3 py-1 text-xs font-semibold text-white hover:bg-emerald-700" data-testid={tid("send-link")}><Send className="h-3.5 w-3.5" />Invia link check-in</button>}
        {templates.length > 0 && (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button type="button" className="flex items-center gap-1 rounded-full border border-emerald-600 px-3 py-1 text-xs font-semibold text-emerald-700 hover:bg-emerald-50" data-testid={tid("templates")}><FileText className="h-3.5 w-3.5" />Messaggi</button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start">
              {templates.map((t) => <DropdownMenuItem key={t.id} onSelect={sendLink(`/bookings/${booking.id}/templates/${t.id}`)} data-testid={`${tid("template")}-${t.id}`}>{t.name}</DropdownMenuItem>)}
            </DropdownMenuContent>
          </DropdownMenu>
        )}
        <button type="button" onClick={() => setEdit(true)} className="text-stone-400 hover:text-primary" aria-label="Modifica telefono" data-testid={tid("edit")}><Pencil className="h-4 w-4" /></button>
      </div>
    );
  }
  return (
    <form className="flex items-center gap-2" onSubmit={(e) => { e.preventDefault(); save(); }} data-testid={tid("form")}>
      <Phone className="h-4 w-4 text-stone-400 shrink-0" />
      <Input type="tel" inputMode="tel" value={value} onChange={(e) => setValue(e.target.value)} placeholder="Aggiungi telefono, es. +39 333 1234567" className="h-9 max-w-xs" data-testid={tid("input")} />
      <Button type="submit" size="sm" variant="outline" disabled={saving || value === phone} data-testid={tid("save")}><Check className="h-4 w-4" /></Button>
    </form>
  );
}
